<div [ngClass]="state">
  @if (selfStepIndex > 0) {
    <div id="separator"></div>
  }

  <div id="step" [ngClass]="state">
    @switch (state) {
      @default {
        <div id="icon">
          {{ selfStepIndex + 1 }}
        </div>
      }
      @case (stepStates.filled) {
        <mat-icon
          id="icon"
          inline
          fontSet="fa"
          class="fa-solid fa-check"
          fontIcon="fa-check"
          >
        </mat-icon>
      }
    }

    <span class="body2">
      {{ stepLabel }}
    </span>
  </div>
</div>
